var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransporteTramRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "d4fkhqvy2b",
    d: "M0 0L13.262 0 13.262 2.179 0 2.179z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i7l0tjmqdd",
    d: "M0 0L3.763 0 3.763 11.346 0 11.346z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M13.12 26H4.88c-.395 0-.715-.327-.715-.73 0-.402.32-.73.715-.73h8.242c.395 0 .715.328.715.73 0 .403-.32.73-.715.73",
    transform: "translate(5.000000, 1.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 1.000000) translate(2.368719, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M12.548 2.179c-.207 0-.412-.091-.553-.267-.231-.288-.573-.453-.937-.453H2.204c-.364 0-.705.165-.936.453-.25.311-.701.357-1.006.101-.306-.255-.35-.715-.1-1.027C.666.36 1.411 0 2.204 0h8.854c.794 0 1.538.36 2.042.986.25.312.206.772-.099 1.027-.133.111-.293.166-.453.166"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M14 16.458l-.018.132c-.125.888-.232 1.656-.44 2.244-.333.902-1.182 1.501-2.116 1.501h-.035.017-4.834c-.934 0-1.783-.6-2.113-1.491-.21-.598-.318-1.366-.443-2.254L4 16.458H.046c.097 2.96.357 5.853.864 6.689.242.4.648.638 1.085.638h14.01c.438 0 .844-.238 1.085-.638.507-.837.767-3.729.864-6.689H14zM14.237 14.999h3.752c.007-.469.011-.93.011-1.378 0-5.093-.912-8.524-.95-8.668l-.014-.044c-.168-.495-.463-.92-.85-1.248-.365 2.11-1.464 8.446-1.95 11.338M3.738 6.392h10.524l.587-3.39c-.157-.035-.32-.061-.486-.075-1.207-.1-4.132-.138-5.36-.141-.96 0-4.153.081-5.342.14-.175.008-.346.032-.512.068l.59 3.398",
    transform: "translate(5.000000, 1.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 1.000000) translate(0.000000, 3.653088)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M3.763 11.346C3.277 8.45 2.176 2.102 1.812 0c-.383.33-.679.758-.847 1.256L.95 1.3C.912 1.443 0 4.875 0 9.968c0 .447.004.91.01 1.378h3.753z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M6.87 17.041c.377 0 .683.312.683.697 0 .384-.306.697-.683.697-.377 0-.683-.313-.683-.697 0-.385.306-.697.683-.697zm4.26 0c.377 0 .683.312.683.697 0 .384-.306.697-.683.697-.377 0-.683-.313-.683-.697 0-.385.306-.697.683-.697zm-5.696-.658c.113.81.21 1.509.369 1.956.116.315.424.534.763.537H11.435c.339-.004.646-.223.766-.547.154-.437.252-1.136.365-1.946l.028-.196c.087-.623.803-4.794 1.415-8.336H3.991c.612 3.542 1.328 7.713 1.415 8.336l.028.196z",
    transform: "translate(5.000000, 1.000000)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteTramRed);
export default __webpack_public_path__ + "static/media/transporteTramRed.1bd9de86.svg";
export { ForwardRef as ReactComponent };